/**
 * ls-photo-uploader.js
 * 为产品配置表单里的「图片/平面图链接」输入框（#photo_link）自动注入
 * 「上传图片」按钮：选择图片后上传到自建后台（/api/coollaa/upload），
 * 并把返回的图片 URL 回填到输入框，随表单一起提交。
 * 兼容主流浏览器（原生 input[type=file] + fetch），上传失败不影响表单手填。
 */
(function () {
  'use strict';

  var API = 'https://api.sifanonline.com/api';
  var SITE = 'longshade.sg';
  var MAX_MB = 20;
  var BTN_ID = 'ls-photo-upload-btn';
  var STYLED = false;

  function ensureStyles() {
    if (STYLED) return;
    STYLED = true;
    var css = document.createElement('style');
    css.textContent =
      '.' + BTN_ID + '{display:inline-flex;align-items:center;gap:6px;padding:8px 14px;' +
      'border:1px solid #1976d2;border-radius:6px;background:#f5f9ff;color:#1976d2;' +
      'font:500 13px/1.4 inherit;cursor:pointer;vertical-align:middle;}' +
      '.' + BTN_ID + ':hover{background:#e3f2fd;}' +
      '.' + BTN_ID + '.is-uploading{opacity:.6;cursor:wait;}' +
      '.' + BTN_ID + '.is-done{border-color:#2e7d32;color:#2e7d32;background:#f0f8f0;}' +
      '.' + BTN_ID + '.is-error{border-color:#c62828;color:#c62828;background:#fff5f5;}' +
      '.ls-photo-upload-status{font-size:12px;color:#666;margin-top:4px;word-break:break-all;}';
    document.head.appendChild(css);
  }

  function uploadFile(file, btn, statusEl, input) {
    if (file.size > MAX_MB * 1024 * 1024) {
      statusEl.textContent = '文件超过 ' + MAX_MB + 'MB，请压缩后重试';
      btn.classList.remove('is-uploading');
      btn.classList.add('is-error');
      return;
    }
    btn.classList.add('is-uploading');
    statusEl.textContent = '上传中：' + file.name;
    var fd = new FormData();
    fd.append('file', file, file.name);
    fetch(API + '/coollaa/upload?site=' + SITE, { method: 'POST', body: fd })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)); })
      .then(function (r) {
        if (!r || !r.fileUrl) throw new Error('no fileUrl');
        input.value = r.fileUrl;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        btn.classList.remove('is-uploading');
        btn.classList.add('is-done');
        statusEl.textContent = '已上传 ✓ ' + file.name;
      })
      .catch(function (e) {
        btn.classList.remove('is-uploading');
        btn.classList.add('is-error');
        statusEl.textContent = '上传失败：' + (e && e.message ? e.message : '请重试或手动粘贴链接');
      });
  }

  function decorate(input) {
    if (input.getAttribute('data-ls-uploader')) return;
    input.setAttribute('data-ls-uploader', '1');
    ensureStyles();

    var fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*,.pdf,.dwg,.dxf';
    fileInput.style.display = 'none';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = BTN_ID;
    btn.className = BTN_ID;
    btn.textContent = '📷 上传图片';

    var statusEl = document.createElement('div');
    statusEl.className = 'ls-photo-upload-status';

    btn.addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () {
      if (fileInput.files && fileInput.files[0]) uploadFile(fileInput.files[0], btn, statusEl, input);
    });

    // 插到输入框后面（保持原表单结构，仅追加兄弟节点）
    var parent = input.parentNode;
    if (input.nextSibling) parent.insertBefore(fileInput, input.nextSibling);
    else parent.appendChild(fileInput);
    parent.insertBefore(btn, fileInput);
    parent.insertBefore(statusEl, fileInput);
  }

  function scan() {
    try {
      var inputs = document.querySelectorAll('input#photo_link, input[name="photo_link"]');
      for (var i = 0; i < inputs.length; i++) decorate(inputs[i]);
    } catch (e) { /* 静默 */ }
  }

  // 配置向导可能动态渲染输入框：MutationObserver 持续监听
  var mo = new MutationObserver(function () { scan(); });
  function start() {
    scan();
    mo.observe(document.body, { childList: true, subtree: true });
    // 兜底：定时扫描（配置向导动态渲染时 MutationObserver 可能错过）
    var n = 0;
    var timer = setInterval(function () {
      scan();
      n++;
      if (document.querySelector('input#photo_link[data-ls-uploader]') || n > 120) clearInterval(timer);
    }, 1500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
